// extracted by mini-css-extract-plugin
export default {"container":"LoadingIndicator-module__container","icon":"LoadingIndicator-module__icon","spinner":"LoadingIndicator-module__spinner"};